/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_No_SessionInputs */

const en_us2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan has no workout with exercises yet.`)
};

const pt_br2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano ainda não tem um treino com exercícios.`)
};

const es_419_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan aún no tiene un entrenamiento con ejercicios.`)
};

const pt_pt2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano ainda não tem um treino com exercícios.`)
};

const fr_fr2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme n'a pas encore de séance avec des exercices.`)
};

const de_de2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan hat noch kein Training mit Übungen.`)
};

const it_it2_today_no_session = /** @type {(inputs: Today_No_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda non ha ancora un allenamento con esercizi.`)
};

/**
* | output |
* | --- |
* | "Your plan has no workout with exercises yet." |
*
* @param {Today_No_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_no_session = /** @type {((inputs?: Today_No_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_No_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_no_session(inputs)
	if (locale === "es-419") return es_419_today_no_session(inputs)
	if (locale === "pt-PT") return pt_pt2_today_no_session(inputs)
	if (locale === "fr-FR") return fr_fr2_today_no_session(inputs)
	if (locale === "de-DE") return de_de2_today_no_session(inputs)
	if (locale === "it-IT") return it_it2_today_no_session(inputs)
	return en_us2_today_no_session(inputs)
});
export { today_no_session as "today.no_session" }